<template>
  <router-link
    class="ff-bzioup bzioup-text logo-link"
    to="/"
  >
    <img
        class="logo"
        :src="src"
        :alt="alt"
    />
    <span>Bzioup.</span>
  </router-link>
</template>

<script>
export default {
    name: 'BzioupLogo',
    props: {
        to: String,
        src: String,
        alt: {
            type: String,
            default: "",
        }
    }
}
</script>


<style lang="scss" scoped>
.logo-link {
    vertical-align: middle;
    display: inline-block;
}
.bzioup-text {
  font-size: 26px;
}
.logo {
    vertical-align: middle;
    margin: 5px;
    width: 30px;
    /* Very slight heartbeat on the brand mark. Same 2.6s two-beat
       rhythm as the app's heart cues, dialed way down so it reads
       as alive, not busy. */
    transform-origin: center;
    animation: bzioup-logo-pump 2.6s ease-in-out infinite;
}

@keyframes bzioup-logo-pump {
    0%, 100% { transform: scale(1); }
    12%      { transform: scale(1.07); }
    24%      { transform: scale(0.98); }
    36%      { transform: scale(1.04); }
    48%      { transform: scale(1); }
}

@media (prefers-reduced-motion: reduce) {
    .logo {
        animation: none;
    }
}
</style>
